import React, { useState } from "preact/compat";
import { FooterProps } from './footer.type';
import { AffLink } from "../../../💎Atoms/AffLink/AffLink";
import { currencyFormatter } from "../../../../helper/currencyFormatter";

export const Footer: React.FunctionComponent<FooterProps> = ({
    t,
    site,
    tab,
    betData,
    selectedBets = [],
    onRemoveGames
  }) => { 
    const [totalToWin, setTotalToWin] = useState(0);

    const partner = tab === "parlay" 
        ? betData.parlayComparisonVm.bestSelectedParlay ? betData.parlayComparisonVm.bestSelectedParlay?.sportsbookVm : null 
        : betData.getBets()[0].selectedBet.sportsbook;
    const link = tab === "parlay"
        ? betData.parlayComparisonVm?.parlayDeepLink ? betData.parlayComparisonVm?.parlayDeepLink : betData.parlayComparisonVm.bestSelectedParlay?.sportsbookVm?.sportsbookClickout 
        : betData.getBets()[0].deepLink ? betData.getBets()[0].deepLink : betData.getBets()[0].selectedBet.sportsbook.sportsbookClickout;


    const footerAction = () => {
        let fBehaviour = '';
        if (tab === "straight") {
            fBehaviour = '';
            
            const tValue = betData.getTotalWins();
            
            setTotalToWin(tValue);
        }
        if (tab === "parlay") {
            fBehaviour = 'cta';
            if (selectedBets && ((selectedBets.filter((sl: number) => sl !== -1)?.length < 2 || selectedBets.filter((sl: number) => sl !== -1)?.length > 12) || betData.isSameGame(selectedBets) > 0)) {
                fBehaviour = 'disabled';
            }    
            if (betData.getStartedGames() !== "") {
                fBehaviour = 'outdated';
            }
        }
        return fBehaviour;
    }

    const [renderAction, setRenderAction] = useState(footerAction())
    setRenderAction(footerAction())

    return (
        <div>
            {betData.getBets() ?
                <div className="betslip-footer position-absolute bottom-0 w-100 p-3 bg-white d-flex flex-column">
                {tab === "straight" ?
                    <div className={`d-flex justify-content-between align-items-center ${site === "covers" ? "fs-7" : "fs-8"} w-100 mb-2`}>
                        {t.total}
                        <b>{currencyFormatter.format(totalToWin)}</b>
                    </div>
                : ''}
                {partner !== null && renderAction === "cta" ?
                    <AffLink 
                        site={site}
                        className={`${site === "covers" ? "fs-7" : "fs-8"} rounded-2 w-100 text-white d-flex align-items-center justify-content-center`}
                        url={link ? link : ''}
                        aalink={`${tab === "parlay" && betData?.parlayComparisonVm?.bestSelectedParlay?.sportsbookVm?.providerBookId ? 'bet-slip-parlay-tab-CTA-quick-bet-click' : 'bet-slip-parlay-tab-CTA-click'}`}
                        type={`${site === "covers" ? "secondary" : "primary"}`}>
                        {tab === "parlay" && betData?.parlayComparisonVm?.bestSelectedParlay?.sportsbookVm?.providerBookId ?
                            <span className="d-flex align-items-center justify-content-start me-1"><span className="mat-icon-quick-logo-white me-1" aria-label={t.cta_quickBet}></span> at </span>
                        : 
                            t.cta}
                        {partner.sportsbookName}
                    </AffLink>
                : ""}
                {renderAction === "outdated" ?
                    <button type="button" className={`btn btn-secondary-outline ${site === "covers" ? "border-secondary" : "border-primary"} rounded-2 w-100`} onClick={onRemoveGames}>
                        {t.button}
                    </button>
                : ""}
                {partner !== null && renderAction === "disabled" ?
                    <AffLink 
                        site={site}
                        className={`${site === "covers" ? "fs-7" : "fs-8"} disabled rounded-2 w-100 text-white d-flex align-items-center justify-content-center`}
                        url={link ? link : ''}
                        aalink={`${tab === "parlay" && betData?.parlayComparisonVm?.bestSelectedParlay?.sportsbookVm?.providerBookId ? 'bet-slip-parlay-tab-CTA-quick-bet-click' : 'bet-slip-parlay-tab-CTA-click'}`}
                        type={`${site === "covers" ? "secondary" : "primary"}`}
                        size="sm"
                        disabled={true}>
                        {tab === "parlay" && betData?.parlayComparisonVm?.bestSelectedParlay?.sportsbookVm?.providerBookId ?
                            <span className="d-flex align-items-center justify-content-start me-1"><span className="mat-icon-quick-logo-white me-1" aria-label={t.cta_quickBet}></span> at </span> 
                        : 
                            t.cta}
                        {partner.sportsbookName}
                    </AffLink>
                : ""}
                </div>
            : 
                ""
            }
        </div>
    )

};